<script>
import axios from '@/utils/axios';
import { countries, states, pincodeWiseAddress } from '@/utils/admin';

export default {
 inject: ['setLoading'],  
  data() {
    return {
     errors: {}, 
     id: '',
     name: '',
    //  code: '',
     email: '',
     mobile: '',
     address: '',
     city: '',
     state: null,
     pincode: '',
     country: null,
     states: [],
     countries: [],
     module_url: 'inventory/warehouses'
    };
  },
  
  methods: {
   
  async warehouse(row = null){
   this.resetForm();
   await this.getCountries();
    if(row !== null){
     this.id = row.id; 
     this.name = row.name;
     this.code = row.code;
     this.city = row.city;
     this.email = row.email;
     this.mobile = row.mobile;
     this.address = row.address;
     this.pincode = row.pincode;
     this.country = this.countries.find(country => country.name === row.country);
    //LOAD STATES
    await this.getStates(this.country?.id);
    this.state = this.states.find(state => state.name === row.state);
   }
  },

   async saveWarehouse(){
    this.errors = {};
    this.setLoading(true); 

    try{
     const payload = {
      name: this.name,  
      // code: this.code,
      city: this.city,
      email: this.email,
      mobile: this.mobile,      
      address: this.address,
      pincode: this.pincode,
      state: this.state?.name,
      country: this.country?.name,
     }; 
     let response = [];
     if(this.id){
      //UPDATE
      response = await axios.put(`/${this.module_url}/${this.id}`, payload);
     }else{
      //CREATE
      response = await axios.post(`/${this.module_url}`, payload);
     }
     this.$swalToast(response.data.message);
     this.$emit('updated'); 
     this.$closeModal('warehouse_modal');
     this.resetForm();
    }catch(error){
     if(error.type == 'validation'){  
      this.errors = error.errors;
     }else{
      this.$swalToast(error.message, 'error');
     }
    }finally{
     this.setLoading(false); 
    }
   },

  async deleteWarehouse(){
   this.errors = {};
   this.setLoading(true); 
   try{
    const response = await axios.delete(`/${this.module_url}/${this.id}`);
    this.$swalToast(response.data.message);
    this.$emit('updated');
    this.$closeModal('warehouse_delete_modal');
   }catch(error){
    if(error.type == 'validation'){
     this.errors = error.errors;
    }else{
     this.$swalToast(error.message, 'error'); 
    }
   }finally{
    this.setLoading(false);
   }
  },

  async getCountries(){
   this.setLoading(true);
   try{
    const response = await countries();
    this.countries = response.data.data;
    if(!this.id){
     //if creating new customer, then set default country 
     this.country = this.countries.find(c => c.name === this.clientAdmin?.company?.country);
    }
    this.getStates(this.country?.id);
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   } 
  },

  onCountrySelect(country){
   this.getStates(country?.id);
  },

  async getStates(country_id){
   this.state = null;
   this.states = [];
    if(country_id){
    try{ 
     const response = await states(country_id);
     this.states = response.data.data;
     //if creating new customer, then set default country 
     this.state = this.states.find(s => s.name === this.clientAdmin?.company?.state);
    }catch(error){
     this.$swalToast(error.message, 'error');
    }
   }  
  },

  checkPincode(){
   if(this.pincode.length < 6){
    this.errors.pincode = ["The pincode field must be 6 digits."];
   }else{
    delete this.errors.pincode;
    clearTimeout(this.pincodeTimeout);
    this.pincodeTimeout = setTimeout(() => {
     this.addressByPincode();
    }, 500);   
   }
  },

  async addressByPincode(){
   this.setLoading(true);
   try{
    const response = await pincodeWiseAddress(this.pincode);
    const data = response.data.data;
    const new_country = data?.country ? this.countries.find(c => c.name === data.country) : this.country;
    this.city = data?.city || this.city;
    if(new_country && new_country?.id !== this.country?.id){
     this.country = new_country;
     await this.getStates(new_country.id);
     this.state = data?.state ? this.states.find(s => s.name === data.state) : this.state;
    }else if(data?.state){
     this.state = this.states.find(s => s.name === data.state);
    }
   }catch(error){
    console.log('Pincode lookup failed:', error.message);
   }finally{
    this.setLoading(false);
   }
  },

  resetForm() {
   this.id = null;
   this.name = '';
  //  this.code = '';
   this.email = '';
   this.mobile = '';
   this.address = '';
   this.city = '';
   this.state = '';
   this.pincode = '';
   this.country = '';
   this.errors = {};
  },

  },
};
</script>

<template>
 
  <!-- ===== ADD / EDIT MODAL ===== -->
  <div class="modal fade" id="warehouse_modal">
    <div class="modal-dialog modal-dialog-centered modal-mg w-100">
      <div class="modal-content" style="border:none;border-radius:14px;overflow:hidden;">
 
        <div class="modal-header" style="background:#f8f9fb;border-bottom:1px solid #f0f1f5;padding:16px 20px;">
          <div style="display:flex;align-items:center;gap:10px;">
            <span style="display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;background:#fff0f0;border-radius:8px;">
              <i class="ti ti-building-warehouse" style="font-size:17px;color:#e84040;"></i>
            </span>
            <h4 class="modal-title" style="font-size:15px;font-weight:600;margin:0;color:#1a1d23;">
              {{ id ? 'Edit' : 'Add' }} Warehouse
            </h4>
          </div>
          <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>
 
        <form @submit.prevent="saveWarehouse">
          <div class="modal-body" style="padding:20px;background:#fff;">
 
            <!-- Section: Basic Info -->
            <div style="font-size:11px;font-weight:700;color:#b0b7c3;text-transform:uppercase;letter-spacing:0.6px;margin-bottom:12px;">
              Basic Information
            </div>
 
            <!-- Name -->
            <div class="row g-3 mb-1">
              <div class="col-md-12">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">
                  Warehouse Name <span class="text-danger">*</span>
                </label>
                <input type="text" class="form-control" v-model="name"
                  style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                <div v-if="errors.name" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;">
                  <i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.name[0] }}
                </div>
              </div>
            </div>
 
            <!-- Contact + Email -->
            <div class="row g-3 mt-1 mb-1">
              <div class="col-md-5">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">
                  Warehouse Contact No <span class="text-danger">*</span>
                </label>
                <input type="text" class="form-control" v-model="mobile"
                  style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                <div v-if="errors.mobile" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;">
                  <i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.mobile[0] }}
                </div>
              </div>
              <div class="col-md-7">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">
                  Warehouse Email ID <span class="text-danger">*</span>
                </label>
                <input type="text" class="form-control" v-model="email"
                  style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                <div v-if="errors.email" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;">
                  <i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.email[0] }}
                </div>
              </div>
            </div>
 
            <!-- Divider -->
            <div style="border-top:1px dashed #f0f1f5;margin:16px 0;"></div>
 
            <!-- Section: Address -->
            <div style="font-size:11px;font-weight:700;color:#b0b7c3;text-transform:uppercase;letter-spacing:0.6px;margin-bottom:12px;">
              Address Details 
            </div>
 
            <!-- Street Address + City -->
            <div class="row g-3 mb-1">
              <div class="col-md-7">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">
                  Street Address <span class="text-danger">*</span>
                </label>
                <input type="text" class="form-control" v-model="address"
                  style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                <div v-if="errors.address" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;">
                  <i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.address[0] }}
                </div>
              </div>
              <div class="col-md-5">
                 <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">
                  Pincode <span class="text-danger">*</span>
                </label>
                <input type="text" class="form-control" v-model="pincode" maxlength="6" @keyup="checkPincode"
                  style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                <div v-if="errors.pincode" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;">
                  <i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.pincode[0] }}
                </div>
              </div>
            </div>
 
            <!-- Pincode + Country + State -->
            <div class="row g-3 mt-1">
              <div class="col-md-3">

                               <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">
                  City <span class="text-danger">*</span>
                </label>
                <input type="text" class="form-control" v-model="city"
                  style="font-size:13px;border:1.5px solid #e8eaf0;border-radius:8px;padding:9px 12px;background:#fafafa;" />
                <div v-if="errors.city" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;">
                  <i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.city[0] }}
                </div>
              </div>
              <div class="col-md-4">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">
                  Country <span class="text-danger">*</span>
                </label>
                <vue-select :options="countries" label="name" v-model="country" @update:modelValue="onCountrySelect" />
                <div v-if="errors.country" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;">
                  <i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.country[0] }}
                </div>
              </div>
              <div class="col-md-5">
                <label style="font-size:12px;font-weight:500;color:#5a6272;margin-bottom:5px;display:block;">
                  State <span class="text-danger">*</span>
                </label>
                <vue-select :options="states" label="name" v-model="state" />
                <div v-if="errors.state" style="color:#e84040;font-size:11.5px;margin-top:4px;display:flex;align-items:center;gap:4px;">
                  <i class="ti ti-alert-circle" style="font-size:12px;"></i> {{ errors.state[0] }}
                </div>
              </div>
            </div>
 
          </div>
 
          <div class="modal-footer" style="background:#f8f9fb;border-top:1px solid #f0f1f5;padding:14px 20px;gap:8px;">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal"
              style="font-size:13px;border-radius:8px;padding:8px 18px;border:1.5px solid #e8eaf0;">
              Cancel
            </button>
            <button type="submit" class="btn btn-primary"
              style="font-size:13px;border-radius:8px;padding:8px 22px;background:#e84040;border:none;font-weight:500;">
              {{ id ? 'Update' : 'Save' }} Warehouse
            </button>
          </div>
        </form>
 
      </div>
    </div>
  </div>
  <!-- /Add -->
 
 
  <!-- ===== DELETE MODAL ===== -->
  <div class="modal fade" id="warehouse_delete_modal">
    <div class="modal-dialog modal-dialog-centered" style="max-width:380px;">
      <div class="modal-content" style="border:none;border-radius:14px;overflow:hidden;">
        <div class="modal-body text-center" style="padding:32px 24px;">
 
          <div style="display:inline-flex;align-items:center;justify-content:center;width:60px;height:60px;background:#fff0f0;border-radius:50%;margin-bottom:16px;">
            <i class="ti ti-trash-x" style="font-size:28px;color:#e84040;"></i>
          </div>
 
          <h5 style="font-size:16px;font-weight:600;color:#1a1d23;margin-bottom:8px;">Delete Warehouse?</h5>
          <p style="font-size:13px;color:#8a8f9e;margin-bottom:24px;line-height:1.6;">
            This action cannot be undone. The warehouse and all its data will be permanently removed.
          </p>
 
          <div style="display:flex;gap:10px;justify-content:center;">
            <a href="javascript:void(0);" class="btn btn-light" data-bs-dismiss="modal"
              style="font-size:13px;border-radius:8px;padding:9px 22px;border:1.5px solid #e8eaf0;color:#5a6272;">
              Cancel
            </a>
            <a href="javascript:void(0);" class="btn btn-danger" @click="deleteWarehouse"
              style="font-size:13px;border-radius:8px;padding:9px 22px;background:#e84040;border:none;font-weight:500;">
              Yes, Delete
            </a>
          </div>
 
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Modal -->
 
 
  <!-- ===== VIEW DETAIL MODAL ===== -->
  <div class="modal fade" id="warehouse_detail_modal">
    <div class="modal-dialog modal-dialog-centered" style="max-width:420px;">
      <div class="modal-content" style="border:none;border-radius:14px;overflow:hidden;">
 
        <div class="modal-header" style="background:#f8f9fb;border-bottom:1px solid #f0f1f5;padding:16px 20px;">
          <div style="display:flex;align-items:center;gap:10px;">
            <span style="display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;background:#fff0f0;border-radius:8px;">
              <i class="ti ti-building-warehouse" style="font-size:17px;color:#e84040;"></i>
            </span>
            <h4 class="modal-title" style="font-size:15px;font-weight:600;margin:0;color:#1a1d23;">{{ name }}</h4>
          </div>
          <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>
 
        <div class="modal-body" style="padding:20px;">
          <div style="display:flex;flex-direction:column;">
 
            <div style="display:flex;padding:10px 0;border-bottom:1px solid #f4f5f8;align-items:flex-start;gap:12px;">
              <span style="min-width:110px;font-size:12px;font-weight:500;color:#9e9e9e;">Name</span>
              <span style="font-size:13px;color:#1a1d23;font-weight:500;">{{ name }}</span>
            </div>
 
            <div v-if="email" style="display:flex;padding:10px 0;border-bottom:1px solid #f4f5f8;align-items:flex-start;gap:12px;">
              <span style="min-width:110px;font-size:12px;font-weight:500;color:#9e9e9e;">Email</span>
              <span style="font-size:13px;color:#1a1d23;">{{ email }}</span>
            </div>
 
            <div v-if="mobile" style="display:flex;padding:10px 0;border-bottom:1px solid #f4f5f8;align-items:flex-start;gap:12px;">
              <span style="min-width:110px;font-size:12px;font-weight:500;color:#9e9e9e;">Contact No</span>
              <span style="font-size:13px;color:#1a1d23;">{{ mobile }}</span>
            </div>
 
            <div style="display:flex;padding:10px 0;align-items:flex-start;gap:12px;">
              <span style="min-width:110px;font-size:12px;font-weight:500;color:#9e9e9e;">Address</span>
              <span style="font-size:13px;color:#1a1d23;line-height:1.6;">
                <span v-if="address">{{ address }}, </span>{{ city }}, {{ state?.name }} - {{ pincode }}
              </span>
            </div>
 
          </div>
        </div>
 
      </div>
    </div>
  </div>
  <!-- /View Detail Modal -->
 
</template>
